import axios from 'axios'
import Vue from 'vue'
import VueCookies from 'vue-cookies'
import store from '../store'
import router from '../router'
import i18n from '../i18n'

Vue.use(VueCookies)

const api = axios.create({
  baseURL: process.env.VUE_APP_API_URL
})

api.interceptors.response.use(
  response => response,
  error => {
    if (error.response.status === 422) {
      store.commit('setErrors', error.response.data.message)
    } else if (error.response.status === 401) {
      const admin = 'administrator'
      if (router.currentRoute.path.indexOf(admin) !== -1) {
        Vue.$cookies.remove('access_token_admin')
        router.push({ name: 'Login' })
      } else {
        store.commit('login/setUserData', null)
        Vue.$cookies.remove('access_token_admin')
        Vue.$cookies.remove('access_token_client')
        Vue.$cookies.remove('account')
        router.push({ name: 'Home Page' })
      }
    } else if (error.response.status === 400) {
      store.commit('login/setUserData', null)
      Vue.$cookies.remove('access_token_admin')
      Vue.$cookies.remove('access_token_client')
      Vue.$cookies.remove('account')
      router.push({ name: 'Home Page' })
    } else {
      return Promise.reject(error)
    }
  }
)

api.interceptors.request.use(function (config) {
  const admin = 'administrator'
  let token = null
  if (router.currentRoute.path.indexOf(admin) !== -1) {
    token = Vue.$cookies.get('access_token_admin')
    document.title = 'GLOCALY console'
  } else {
    token = Vue.$cookies.get('access_token_client')
  }
  config.headers.common = {
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/json',
    Accept: 'application/json',
    'X-localization': i18n.locale
  }

  return config
})

export default api
